import { Button, Form } from "@/components/ui";
import { AppModal } from "@/components/ui/AppModal/AppModal";
import { MultiCategorySelectFormField } from "@/components/ui/FormFields/MultiCategorySelectFormField/MultiCategorySelectFormField";
import { useState } from "react";
import { useForm } from "react-hook-form";

export function MatterStatusActionModal({
  action,
  open,
  onClosed,
  statuses,
  busy,
  onClose,
  onSubmit,
  submitLabel,
  overlayClassName,
  className,
}: {
  action: "referred" | "closed" | "reopen";
  open: boolean;
  onClosed: () => void;
  statuses: { id: string; label: string }[];
  busy: boolean;
  onClose: () => void;
  onSubmit: (statusId: string) => Promise<void>;
  submitLabel?: string;
  overlayClassName?: string;
  className?: string;
}) {
  const [statusDropdownOpen, setStatusDropdownOpen] = useState(false);
  const form = useForm({ defaultValues: { statusId: "" } });
  const statusId = form.watch("statusId");
  const title =
    action === "reopen"
      ? "Reopen case"
      : action === "referred"
        ? "Refer case out"
        : "Close case";
  const label =
    action === "reopen"
      ? "Reopening status"
      : action === "referred"
        ? "Referral status"
        : "Closing status";

  return (
    <AppModal
      open={open}
      overlayClassName={overlayClassName}
      className={className}
      onCloseAutoFocus={(event) => {
        event.preventDefault();
        onClosed();
      }}
      onOpenChange={(open) => {
        if (!open && !busy) {
          form.reset();
          setStatusDropdownOpen(false);
          onClose();
        }
      }}
      title={title}
      size="md"
      loading={busy}
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="outline" disabled={busy} onClick={onClose}>
            Cancel
          </Button>
          <Button
            disabled={
              busy || !statuses.some((status) => status.id === statusId)
            }
            onClick={() => void onSubmit(statusId)}
          >
            {submitLabel ?? title}
          </Button>
        </div>
      }
    >
      <Form {...form}>
        <form
          onSubmit={(event) => {
            event.preventDefault();
          }}
        >
          <MultiCategorySelectFormField
            label={label}
            register={form.register("statusId")}
            items={[
              {
                category: "Statuses",
                items: statuses.map((status) => ({
                  value: status.id,
                  label: status.label,
                })),
              },
            ]}
            placeholder={`Select ${label.toLowerCase()}...`}
            searchPlaceholder="Search statuses..."
            emptyMessage={`No ${
              action === "reopen"
                ? "active"
                : action === "referred"
                  ? "referral"
                  : "closed"
            } statuses configured.`}
            open={statusDropdownOpen}
            setOpen={setStatusDropdownOpen}
            disabled={busy}
          />
        </form>
      </Form>
    </AppModal>
  );
}
